import React from 'react';
import ReactDOM from 'react-dom/client';
import SimplePage from './SimplePage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SimplePage />
  </React.StrictMode>
);